import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Context } from '../..';
import { fetchReverseGeocode, helpFindCity } from '../../http/basketApi';

const CitySelectionModal = ({ 
  cityForOrder, 
  setSityHandler, 
  closeModal,
  isOpen 
}) => {
  const { delivery} = useContext(Context)
  const [searchCityValue, setSearchCityValue] = useState('');
  const [dadataFindResponse, setDadataFindResponse] = useState(null);
  const inputRef = useRef(null)

  useEffect(() => {
  

    if (!searchCityValue) {
      setDadataFindResponse(null);
      return;
    }

    const timer = setTimeout(() => {
      helpFindCity(searchCityValue).then((response) => {
        const data = JSON.parse(response);
        setDadataFindResponse(data.suggestions.length ? data.suggestions : null);
      });
    }, 300);

    return () => clearTimeout(timer);
  }, [searchCityValue]);

  const handleCitySelect = (item) => {
    
    setSityHandler(item);
    setSearchCityValue('');
    closeModal();
  };

  const handleConfirm = useCallback(async () => {
      try {
        const userCoords = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            pos => resolve({ lat: pos.coords.latitude, lon: pos.coords.longitude }),
            err => reject(err)
          );
        });
  
        const response = await fetchReverseGeocode({
          lat: String(userCoords.lat),
          lon: String(userCoords.lon),
        });

        if (response.suggestions?.length) {
          const { city } = response.suggestions[0].data;
          if (city) {
            setSearchCityValue(city)
          }
        }
      } catch (error) {
        console.error('fetchReverseGeocode error: ', error);
      }
  }, [delivery]);

  useEffect(() => {
    if (isOpen) {
      inputRef.current?.focus()
    }
  }, [isOpen])

  if (!isOpen) return null;

  return (
    <div className="city_changer_function_modal_wrapper">
      <div className="functional_modal_support_wrapper">
        <input
          ref={inputRef}
          value={searchCityValue}
          onChange={(e) => setSearchCityValue(e.target.value)}
          placeholder="Населенный пункт"
          className="search_city_input_fuctional_modal"
          type="text"
        />
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.8">
            <path
              d="M21.0008 20.9998L15.8038 15.8028M15.8038 15.8028C17.2104 14.3962 18.0006 12.4885 18.0006 10.4993C18.0006 8.51011 17.2104 6.60238 15.8038 5.19581C14.3972 3.78923 12.4895 2.99902 10.5003 2.99902C8.51108 2.99902 6.60336 3.78923 5.19678 5.19581C3.79021 6.60238 3 8.51011 3 10.4993C3 12.4885 3.79021 14.3962 5.19678 15.8028C6.60336 17.2094 8.51108 17.9996 10.5003 17.9996C12.4895 17.9996 14.3972 17.2094 15.8038 15.8028Z"
              stroke="#757575"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>

        <button className='geocode_button' type='button' onClick={handleConfirm}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.0176 3.00531L20.1115 3L20.2267 3.00709L20.3064 3.02126L20.4154 3.05226L20.5101 3.09301L20.5987 3.1435L20.6784 3.20285L20.7511 3.26929L20.7971 3.32155L20.8698 3.42431L20.9158 3.50935C20.9575 3.59793 20.9841 3.69183 20.9956 3.78927L21 3.88317C21 3.94961 20.9929 4.01516 20.9787 4.07805L20.9477 4.18701L15.1615 20.2001C15.0518 20.4389 14.8759 20.6412 14.6547 20.783C14.4334 20.9248 14.1762 21.0001 13.9134 21C13.6767 21.0007 13.4439 20.9402 13.2376 20.8242C13.0313 20.7083 12.8585 20.5408 12.7361 20.3383L12.6785 20.2258L9.70925 14.289L3.80079 11.3339C3.58217 11.2339 3.39363 11.0782 3.25403 10.8825C3.11443 10.6868 3.02867 10.4579 3.00531 10.2186L3 10.0866C3 9.59055 3.26663 9.13701 3.74498 8.87303L3.869 8.81102L19.8289 3.04783L19.9228 3.02126L20.0176 3.00531Z" stroke="#1B1B1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </button>
      </div>

      {cityForOrder && !searchCityValue && (
        <div className="favorite_citys_functional_modal">
          <div className="citys_map_wrapper">
            {cityForOrder.map((item) => (
              <div
                key={item.name}
                onClick={() => handleCitySelect(item)}
                className="one_city_functional_modal"
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
      )}

      {searchCityValue && dadataFindResponse && (
        <div className="order_response_city_list">
          {dadataFindResponse.map((item) => (
            <div
              onClick={() => handleCitySelect(item)}
              className="order_modal_one_city_item"
              key={item.value}
            >
              <span className="order_modal_one_city_item_name">{item.value}</span>
            </div>
          ))}
        </div>
      )}

      {searchCityValue && !dadataFindResponse && (
        <div className="no_cities_found">
          Город не найден. Попробуйте другой запрос.
        </div>
      )}
    </div>
  );
};

export default CitySelectionModal;